<template>
   <div class="fileInput">
      <div class="fileUploadDropZone" :class="{'activeZone' : isActive}" @drop.prevent="onDrop" @dragenter.prevent="setActive" @dragover.prevent="setActive" @dragleave.prevent="setInactive">

         <svg width="70" height="58" viewBox="0 0 70 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M64.6154 0H5.38462C3.95653 0 2.58693 0.555518 1.57712 1.54435C0.567306 2.53317 0 3.87431 0 5.27273V52.7273C0 54.1257 0.567306 55.4668 1.57712 56.4557C2.58693 57.4445 3.95653 58 5.38462 58H64.6154C66.0435 58 67.4131 57.4445 68.4229 56.4557C69.4327 55.4668 70 54.1257 70 52.7273V5.27273C70 3.87431 69.4327 2.53317 68.4229 1.54435C67.4131 0.555518 66.0435 0 64.6154 0ZM44.4231 15.8182C45.2218 15.8182 46.0026 16.0501 46.6667 16.4846C47.3308 16.9192 47.8485 17.5368 48.1541 18.2594C48.4598 18.982 48.5398 19.7771 48.3839 20.5442C48.2281 21.3113 47.8435 22.016 47.2787 22.569C46.7139 23.1221 45.9943 23.4987 45.2109 23.6513C44.4276 23.8039 43.6156 23.7256 42.8776 23.4263C42.1397 23.1269 41.509 22.6201 41.0652 21.9698C40.6215 21.3194 40.3846 20.5549 40.3846 19.7727C40.3846 18.7239 40.8101 17.7181 41.5675 16.9764C42.3248 16.2348 43.352 15.8182 44.4231 15.8182ZM5.38462 52.7273V43.5L22.8846 26.3636L49.8077 52.7273H5.38462ZM64.6154 52.7273H57.4236L45.3082 40.8636L52.0389 34.2727L64.6154 46.5911V52.7273Z" fill="#435666"/>
         </svg>

         <p>Click Add File</p>
         <p class="secondary-text">or</p>
         <p class="secondary-text">Drag and Drop Files to Upload</p>

         <input type="file" ref="filesRef" :id="id" class="position-absolute invisible" v-on:change="onInputChange" :accept="acceptedFileTypeList.toString()"/>

         <label class="btn btn-add-file" :for="id">Add File</label>
      </div>

      <div class="fileList mx-2" v-show="fileList.length > 0">
         <div v-for="file of fileList" :key="file.id" class="p-1">
            <div>

               <span class="p-2">{{ file.name }}</span>
               <span class="removeFile" @click="removeFile(file)" title="Click to remove file"><i class="fa fa-times fa-xs"></i></span>
            </div>
         </div>
      </div>

   </div>
</template>

<script>
const events = ['dragenter', 'dragover', 'dragleave', 'drop'];

export default {
   props: {
      id: {
         type: String
      },
      acceptedFileType: {
         type: String, // each type must be separated by comma
         default: ""
      },
      pdfLink: {
         type: String
      }
   },
   emits: ['fileListChange'],
   data() {
      return {
         isActive: false,
         inactiveTimeout: null,
         fileList: [], // for viewing purposes
         convertedFileList: [], // converted to base64 files, will be passed to parent component
         isDuplicateFile: false,
         duplicateFiles: [],
         acceptedFileTypeList: [],
         isFileNotAccepted: false,
         notAcceptedFiles: [],
         link: null,
      };
   },
   mounted() {
      this.link = this.pdfLink
      events.forEach((eventName) => {
         document.body.addEventListener(eventName, this.preventDefaults);
      });

      if (this.acceptedFileType !== "") {
         this.mapAcceptedFileTypes();
      }
   },
   unmounted() {
      events.forEach((eventName) => {
         document.body.removeEventListener(eventName, this.preventDefaults);
      });
   },
   methods: {
      preventDefaults(e) {
         e.preventDefault();
      },
      onDrop(e) {
         this.setInactive();
         this.addFiles(e.dataTransfer.files);
      },
      setActive() {
         this.isActive = true;
         clearTimeout(this.inactiveTimeout);
      },
      setInactive() {
         this.inactiveTimeout = setTimeout(() => {
            this.isActive = false;
         }, 50);
      },
      onInputChange(e) {
         this.addFiles(e.target.files);
         e.target.value = null;
      },
      addFiles(files) {
         if (!files || files.length === 0) {
            console.warn('No files detected. Please re-attach the file again.');
            return;
         }

         const file = files[0];

         if (this.isFileExisting(file) || !this.isFileAccepted(file)) {
            if (this.isFileExisting(file)) {
               this.isDuplicateFile = true;
               this.duplicateFiles.push({
                  name: file.name
               });
               setTimeout(() => {
                  this.isDuplicateFile = false;
                  this.duplicateFiles = [];
               }, 2500);
            }

            if (!this.isFileAccepted(file)) {
               this.isFileNotAccepted = true;
               this.notAcceptedFiles.push({
                  name: file.name
               });
               setTimeout(() => {
                  this.isFileNotAccepted = false;
                  this.notAcceptedFiles = [];
               }, 2500);
            }
         } else {
            this.fileList[0] = file;
            this.convertedFileList.push(this.convertFileToBase64(file));
         }

         this.$emit('fileListChange', { type: this.id, files: this.fileList[0] });
      },
      removeFile(file) {
         const index = this.fileList.indexOf(file);
         if (index > -1) {
            this.fileList.splice(index, 1);
            this.convertedFileList.splice(index, 1);
         }

         this.$emit('fileListChange', { type: this.id, files: this.convertedFileList });

         if (this.link)
            this.link = null;

      },
      convertFileToBase64(file) {
         // convert to base64
         let reader = new FileReader();
         let fileInfo = {};

         let fileName = file.name;
         let extType = fileName.substring(fileName.lastIndexOf('.'));

         reader.readAsDataURL(file);
         reader.onload = () => {
            fileInfo.encoded = reader.result.split(',')[1];
            fileInfo.name = fileName;
            fileInfo.extension = extType;
         };
         return fileInfo;
      },
      isFileExisting(file) {
         let exists = this.fileList.some((f) => {
            return this.fileInfo(f) === this.fileInfo(file);
         });

         return exists;
      },
      isFileAccepted(file) {
         if (this.acceptedFileTypeList.length > 0) {
            let fileType = file.name.substring(file.name.lastIndexOf('.'));
            let isAccepted = this.acceptedFileTypeList.some((type) => {
               return type === fileType;
            });

            return isAccepted;
         } else {
            return true;
         }
      },
      mapAcceptedFileTypes() {
         if (this.acceptedFileType !== "") {
            if (this.acceptedFileType.includes(",")) {
               let fileType = this.acceptedFileType.split(",");
               fileType.forEach((type) => {
                  this.acceptedFileTypeList.push("." + type.trim());
               });
            } else {
               this.acceptedFileTypeList.push("." + this.acceptedFileType);
            }
         }
      },
      fileInfo(file) {
         return file.name + "-" + file.size + "-" + file.lastModified + "-" + file.type;
      },
      resetForm() {
         this.fileList = [];
         this.convertedFileList = [];
      }
   }
};
</script>


<style scoped>
.fileUploadDropZone {
  width: 100%;
  height: 234px;
  border: 3px dashed #00A0C1;
  background-image: none;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 0.2s ease-out;
  text-align: center;
  padding: 1rem;
  background-color: #fff;
}

.fileUploadDropZone p {
  margin: 0;
  font-weight: 500;
  color: #435666;
}

/* --- START: UPDATED TEXT STYLES --- */
/* Replaced p.small with a more specific class */
.fileUploadDropZone .secondary-text {
  /* Typography from Figma */
  font-weight: 400;
  font-style: italic;
  font-size: 14px;
  line-height: 1.25; /* 125% line height */
  color: #435666;
}
/* --- END: UPDATED TEXT STYLES --- */

.activeZone {
  background-color: #f5f5f5;
  border-color: #0d6efd;
}

.btn-add-file {
  width: 100px;
  height: 30px;
  padding: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: #F3994D;
  border: 1px solid #F3994D;
  color: #fff;
  font-weight: 900;
  font-size: 14px;
  line-height: 1;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  margin-top: 0.5rem;
}

.btn-add-file:hover {
  background-color: #e08d45;
  border-color: #e08d45;
  color: #fff;
}

.removeFile {
   color: red;
}

.removeFile:hover {
   cursor: pointer;
}

.fileList {
   border: 2px solid #f5f5f5;
   border-radius: 10px;
}
</style>